export { cn } from 'cn';

/** Backed by the `shimmer` utility in `../styles/base.css`, so every theme's host has the keyframe. */
export const SHIMMER_CLASSES = 'shimmer';
